// extracted by mini-css-extract-plugin
export default {"root":"KeyValueCard_root__fYEsb"};